export const PLATFORM_ROLES = {
    "admin": "admin"
}